import { Header3 } from 'components/UI/Brand/text';
import CustomImage from 'components/UI/CustomImage/CustomImage';
import { IGeneralSection } from 'interfaces/IMarketing';
import ArrowSearchLink from 'components/UI/Links/ArrowSearchLink';
import ContentfulRenderer from 'components/ContentfulRenderer';
import { AlertBox, LinkText } from 'components';
import { ImageCroppings } from './ImageCroppings';
import getPracticalInfoLinks from './getPracticalInfoLinks';
import { HEADER_SIZE } from './utils/getHeader.util';
import styles from './styles.module.scss';

interface ILeftSectionA {
  article: IGeneralSection;
  isArticle: boolean;
  highestHeadingSize?: HEADER_SIZE;
}

const LeftSectionA = ({
  article,
  isArticle,
  highestHeadingSize = HEADER_SIZE.H1,
}: ILeftSectionA) => {
  let imageWidth = 272;
  let imageHeight = 272;

  switch (article.croppingSize) {
    case ImageCroppings.Tall:
      imageWidth = 272;
      imageHeight = 482;
      break;
    case ImageCroppings.Square:
      imageWidth = 272;
      imageHeight = 272;
      break;
    default:
      imageWidth = 544;
      imageHeight = 306;
  }

  return (
    <div className={styles.leftSectionA} id={article.title}>
      <div className={styles.imageContainer}>
        {article.media && (
          <CustomImage
            width={imageWidth}
            height={imageHeight}
            className={styles.image}
            src={article.media}
            alt={article.title}
          />
        )}
      </div>
      <div
        className={
          article.media ? styles.textContainer : styles.textContainer100
        }
        style={isArticle ? { marginTop: 0 } : {}}
      >
        <Header3 as="h2" className={styles.sectionTitle}>
          {article.title}
        </Header3>
        <ContentfulRenderer
          highestHeadingSize={HEADER_SIZE.H4}
          highestDOMHeadingSize={HEADER_SIZE.H3}
        >
          {article.longDescription}
        </ContentfulRenderer>
        {article.infoBox && (
          <AlertBox type="info" OverrideIcon=" " className={styles.infoBox}>
            <ContentfulRenderer highestHeadingSize={highestHeadingSize}>
              {article.infoBox}
            </ContentfulRenderer>
          </AlertBox>
        )}
        {(article.link?.type === 'hyperlink' ||
          article.link?.type === 'articleContainerLink') && (
          <div className={styles.linkContainer}>
            {article.id === '4yDMXsd9I9PhVxbLxQhg2r' ? (
              getPracticalInfoLinks()
            ) : (
              <LinkText
                href={
                  article.link.type === 'hyperlink'
                    ? article.link.hyperlink
                    : article.link.link
                }
              >
                {article.link.title}
              </LinkText>
            )}
          </div>
        )}
        {article.link && article.link.type === 'search criteria' && (
          <div className={styles.linkContainer}>
            <ArrowSearchLink link={article.link} />
          </div>
        )}
      </div>
    </div>
  );
};

export default LeftSectionA;
